export const getProportion = (
  width,
  height,
  maxWidth,
  maxHeight,
  w,
  h,
  scaleByWidth
) => {
  let W = 0
  let H = 0
  if (maxHeight) {
    // 按比例压缩之后
    const byWidth = imgCompressd(width, height, maxWidth, maxHeight)
    if (byWidth) {
      if (width > maxWidth) {
        W = maxWidth
        const proportionH = (height * maxWidth) / width
        H = proportionH > maxHeight ? maxHeight : proportionH
      } else if (height > maxHeight) {
        H = maxHeight
        const proportionW = (width * maxHeight) / height
        W = proportionW > maxWidth ? maxWidth : proportionW
      } else {
        W = width
        H = height
      }
    } else {
      if (height > maxHeight) {
        H = maxHeight
        const proportionW = (width * maxHeight) / height
        W = proportionW > maxWidth ? maxWidth : proportionW
      } else if (width > maxWidth) {
        W = maxWidth
        const proportionH = (height * maxWidth) / width
        H = proportionH > maxHeight ? maxHeight : proportionH
      } else {
        W = width
        H = height
      }
    }
  } else {
    W = w
    H = h
  }
  return {
    width: W || width,
    height: H || height,
  }
}

/**
 *    计算按照宽/高压缩图片
 * **/
export const imgCompressd = (width, height, maxWidth, maxHeight) => {
  if (width > maxWidth && height > maxHeight) {
    return maxWidth / width < maxHeight / height
  } else if (width > maxWidth) {
    return true
  } else if (height > maxHeight) {
    return false
  }
}

// 坐标转换
export const getDataSource = (
  data = {},
  originSizeWidth,
  originSizeHeight,
  CanvasSizeWidth,
  CanvasSizeHeight
) => {
  const _dataSource = data.points
  const x1 = [
    (_dataSource[0][0] / originSizeWidth) * CanvasSizeWidth,
    (_dataSource[0][1] / originSizeWidth) * CanvasSizeWidth,
  ]
  const x2 = [
    (_dataSource[1][0] / originSizeHeight) * CanvasSizeHeight,
    (_dataSource[0][1] / originSizeHeight) * CanvasSizeHeight,
  ]
  const x3 = [
    (_dataSource[1][0] / originSizeHeight) * CanvasSizeHeight,
    (_dataSource[1][1] / originSizeHeight) * CanvasSizeHeight,
  ]
  const x4 = [
    (_dataSource[0][0] / originSizeHeight) * CanvasSizeHeight,
    (_dataSource[1][1] / originSizeHeight) * CanvasSizeHeight,
  ]
  return [x1, x2, x3, x4]
}

// 矩形
export const drawRect = (el, canvasSystem) => {
  let ctx = el
  const { points, color } = canvasSystem
  ctx.beginPath()
  ctx.strokeStyle = color || 'red'
  ctx.fillStyle = 'rgba(0, 0, 0, 0)'
  ctx.lineWidth = 3
  ctx.moveTo(points[0][0], points[0][1])
  for (let i = 1; i <= points.length - 1; i++) {
    ctx.lineTo(points[i][0], points[i][1])
  }
  ctx.closePath()
  ctx.fill()
  ctx.stroke()
}

export const base64ToUrl = (base) => {
  //需要手动去掉data:image/png;base64,
  //base64-->blob
  const byteCharacters = atob(base)
  const byteNumbers = new Array(byteCharacters.length)
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }
  const byteArray = new Uint8Array(byteNumbers)
  const blob = new Blob([byteArray], { type: 'image/jpeg' })
  //blob-->url
  let binaryData = []
  binaryData.push(blob)
  let url = URL.createObjectURL(new Blob(binaryData))
  return url
}

export const base64ToFile = (base64, filename, contentType) => {
  var arr = base64.split(',') //去掉base64格式图片的头部
  var bstr = atob(arr[1]) //atob()方法将数据解码
  var leng = bstr.length
  var u8arr = new Uint8Array(leng)
  while (leng--) {
    u8arr[leng] = bstr.charCodeAt(leng) //返回指定位置的字符的 Unicode 编码
  }
  return new File([u8arr], filename, { type: contentType })
}
